import React, { FC } from 'react';
import { Title, faFile, PageContainer } from '@/ui/components';
import { useTranslate } from '@/translations';
import { Card } from 'antd';
import { OrderDataGrid } from './components/OrderDataGrid';

export const Order: FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('orderSummary')} icon={faFile} />
      <Card>
        <OrderDataGrid />
      </Card>
    </PageContainer>
  );
};
